<template>
<div class="dischargeLock table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">放电锁列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="IMEI号:">
                <el-input v-model="form.imei" @input="validateImei"></el-input>
            </el-form-item>
            <el-form-item label="开关:">
                <el-select v-model="form.switchStatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="开" value="1"></el-option>
                    <el-option label="关" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="openAddDialog">新增</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="IMEI号" prop="imei" show-overflow-tooltip></el-table-column>
            <el-table-column label="开关" prop="switchStatus" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.switchStatus === 1 ? '开' : '关' }}
                </template>
            </el-table-column>
            <el-table-column label="重置次数" prop="rebootCount" show-overflow-tooltip></el-table-column>
            <el-table-column label="单次放电总数" prop="batteryLevel" show-overflow-tooltip></el-table-column>
            <el-table-column label="更新时间" prop="updateTime" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button :disabled="scope.row.rebootCount>= 10" type="primary" size="mini" class="themed-button"  @click="handleEdit(scope.row)">重置</el-button>
                    <el-button type="danger" size="mini" class="themed-button"  @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" v-if="dialogVisible">
        <el-form :model="dialogForm" ref="dialogForm" :rules="rules" label-width="120px">
            <el-form-item label="IMEI号" prop="imei">
                <el-input v-model="dialogForm.imei" type="textarea" :autosize="{ minRows: isEdit ? 1 : 5, maxRows: isEdit ? 1 : 5 }" :disabled="isEdit" @input="validateImeis"></el-input>
            </el-form-item>
            <el-form-item label="重置次数" prop="rebootCount">
                <el-input v-model="dialogForm.rebootCount" type="number" step="1" min="1" max="10" oninput="this.value = Math.max(this.value, 1);this.value = Math.min(this.value, 10);" :disabled="isEdit"></el-input>
            </el-form-item>
            <el-form-item label="单次放电总数" prop="batteryLevel">
                <el-input v-model="dialogForm.batteryLevel" type="number" step="1" min="0" max="25" oninput="this.value = Math.floor(this.value);this.value = Math.max(this.value, 0);this.value = Math.min(this.value, 25);"></el-input>
            </el-form-item>
            <el-form-item label="开关" prop="switchStatus">
                <el-radio-group v-model="dialogForm.switchStatus">
                    <el-radio label="1">开</el-radio>
                    <el-radio label="0">关</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { listDischargeLock, saveDischargeLock, deleteDischargeLock, batchSaveDischargeLock } from '@/api/meCardBindManagement/dischargeLock.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'

export default {
    mixins: [resize],
    data() {
        return {
            form: {
                imei: '',
                switchStatus: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            
            dialogVisible: false,
            dialogTitle: '',
            isEdit: false,
            dialogForm: {
                imei: '',
                rebootCount: 1,
                batteryLevel: 0,
                switchStatus: '1',
                id: ''
            },
            rules: {
                imei: [
                    { required: true, message: '请输入IMEI号', trigger: 'blur' }
                ],
                rebootCount: [
                    { required: true, message: '请输入重置次数', trigger: 'blur' }
                ],
                batteryLevel: [
                    { required: true, message: '请输入单次放电总数', trigger: 'blur' }
                ],
                switchStatus: [
                    { required: true, message: '请选择开关状态', trigger: 'change' }
                ]
            }
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        // 获取列表数据
        fetchData() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            listDischargeLock(params).then(res => {
                    this.tableData = res.rows || []
                    this.total = res.total || 0
            })
        },
        // 搜索
        searchData() {
            this.currentPage = 1
            this.fetchData()
        },
        // 打开新增弹窗
        openAddDialog() {
            this.dialogTitle = '新增放电锁'
            this.isEdit = false
            this.dialogForm = {
                imei: '',
                rebootCount: 1,
                batteryLevel: 0,
                switchStatus: '1',
                id: ''
            }
            this.dialogVisible = true
        },
        // 编辑
        handleEdit(row) {
            this.dialogTitle = '重置放电锁'
            this.isEdit = true
            this.dialogForm = { 
                ...row,
                switchStatus: row.switchStatus.toString()
            }
            this.dialogForm.rebootCount =  parseInt(this.dialogForm.rebootCount)  + 1 
            this.dialogVisible = true
        },
        // 删除
        handleDelete(row) {
            this.$confirm('确认删除该记录吗？').then(() => {
                deleteDischargeLock({ id: row.id }).then(res => {
                    if (res.code === '0') {
                        messageBox(this,'删除成功')
                        this.fetchData()
                    }
                })
            })
        },
        // 提交表单
        submitForm() {
            this.$refs.dialogForm.validate(valid => {
                if (valid) {
                    const params = {
                        ...this.dialogForm
                    }
                    if (!this.isEdit) {
                        // 新增时使用批量保存接口
                        params.imeis = params.imei
                        batchSaveDischargeLock(params).then(res => {
                            if (res.code === '0') {
                                messageBox(this,'操作成功')
                                this.dialogVisible = false
                                this.fetchData()
                            }
                        })
                    } else {
                        // 重置时使用保存接口
                        saveDischargeLock(params).then(res => {
                            if (res.code === '0') {
                                messageBox(this,'操作成功')
                                this.dialogVisible = false
                                this.fetchData()
                            }
                        })
                    }
                }
            })
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },
        // IMEI号输入验证（只允许数字）
        validateImei(value) {
            this.form.imei = value.replace(/\D/g, '');
        },
        // 批量IMEI号输入验证（只允许数字和换行）
        validateImeis(value) {
            this.dialogForm.imei = value.replace(/[^\d\n]/g, '');
        },
    }
}
</script>

<style lang="scss" scoped>
.dischargeLock {
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    
    .title-box {
        margin-bottom: 20px;
        
      
    }
    
    .content-box {
        margin-bottom: 20px;
    }
    
    .pagination {
        text-align: right;
    }
}
</style>
